import usePlaidLink from 'hooks/usePlaidLink'
import { useEffect, useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { setBackdropLoading } from 'actions/status'
import { createPlaidPublicToken } from 'api/trackedAccountProviders'
import { reconnectTrackedAccountProvider } from 'actions/trackedAccountProviders'

const useReconnectTrackedAccountProvider = (providerId) => {
  const [plaidPublicToken, setPlaidPublicToken] = useState(null)
  const dispatch = useDispatch()

  const setLoading = useCallback((value) => {
    dispatch(setBackdropLoading(value))
  }, [dispatch])

  const handleSuccess = useCallback(() => {
    setLoading(false)
    dispatch(reconnectTrackedAccountProvider(providerId)).then(() => {
      setLoading(false)
    })
  }, [dispatch, providerId, setLoading])

  const { open: openPlaid, ready: plaidReady } = usePlaidLink(
    {
      onSuccess: handleSuccess,
      linkCustomizationName: 'for_funding_account',
      publicToken: plaidPublicToken,
      onExit: () => setLoading(false)
    }
  )

  const startUpdate = () => {
    setLoading(true)
    createPlaidPublicToken(providerId).then(({ data: { publicToken } }) => {
      setPlaidPublicToken(publicToken)
    })
  }

  useEffect(() => {
    if(plaidReady && plaidPublicToken) {
      openPlaid()
    }
  }, [plaidReady, plaidPublicToken, openPlaid])

  return startUpdate
}


export default useReconnectTrackedAccountProvider
